import React from 'react';
import BasicForm from './containers/BasicForm';
import FamilyFrom from './containers/FamilyForm';


export default (props) => {
  const { type } = props.match.params;
  if (type.startsWith('familyform')) {
    return <FamilyFrom type={type} {...props} />
  }
  const isExtended = type.startsWith('extform');
  return <BasicForm isExtended={isExtended} type={type} {...props} />
}
